import { Curve } from "./Curve";
import { CurveModifier } from "./modifiers/CurveModifier";
import { CurveModifierStack } from "./CurveModifierStack";
import { AudioBuilderContext } from "../AudioBuilderContext";

export class ModifiableCurve
{
  #curve:Curve = new Curve();
  get curve(){ return this.#curve;}

  #modifierStack:CurveModifierStack = new CurveModifierStack();  
  get modifierStack(){ return this.#modifierStack; }

  getModifiedCurve( context:AudioBuilderContext )
  {
    return this.#modifierStack.modify( this.#curve, context );
  }
}